import { create } from 'zustand';

type ShallowRoutingStore = {
  shallowSearchParams: URLSearchParams;
  setShallowSearchParams: (href: string, queryString: string) => void;
  resetShallowSearchParams: () => void;
};

export const useShallowSearchParams = create<ShallowRoutingStore>((set) => ({
  shallowSearchParams:
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams(),
  setShallowSearchParams: (href: string, queryString: string) => {
    window.history.replaceState(
      { ...window.history.state, as: href, url: href },
      '',
      href,
    );
    const searchParams = new URLSearchParams(queryString);
    set({ shallowSearchParams: searchParams });
  },
  resetShallowSearchParams: () =>
    set({ shallowSearchParams: new URLSearchParams() }),
}));

export default useShallowSearchParams;
